/* No cart changes. Media loads on request; interaction signals require analytics consent. */
(function(){
  'use strict';
  if(window.bmOwnerExperienceReady)return;
  window.bmOwnerExperienceReady=true;
  function track(action,root){
    try{
      if(!window.Shopify||!Shopify.customerPrivacy||Shopify.customerPrivacy.analyticsProcessingAllowed()!==true)return;
      if(Shopify.theme&&Shopify.theme.role!=='main')return;
      var scope=root||document.querySelector('[data-bmo-root]');
      var data={event:'bm_ownership_interaction',action:action,product_handle:scope&&scope.dataset.bmoProduct||'',model:scope&&scope.dataset.bmoModel||'',locale:document.documentElement.lang||'en',path:location.pathname};
      if(Array.isArray(window.dataLayer))window.dataLayer.push(data);
      if(Shopify.analytics&&typeof Shopify.analytics.publish==='function')Shopify.analytics.publish('bm_ownership_interaction',data);
    }catch(_){}
  }
  document.addEventListener('click',function(event){
    var view=event.target.closest('[data-bmo-view]');
    if(view){
      var root=view.closest('[data-bmo-root]');if(!root)return;
      var photo=root.querySelector('[data-bmo-image]'),caption=root.querySelector('[data-bmo-caption-text]');
      if(!photo||!caption)return;
      photo.src=view.dataset.bmoSrc;photo.alt=view.dataset.bmoCaption;
      caption.textContent=view.dataset.bmoCaption;
      root.querySelectorAll('[data-bmo-view]').forEach(function(button){button.setAttribute('aria-pressed',String(button===view));});
      track('view_'+view.dataset.bmoView,root);
      return;
    }
    var link=event.target.closest('[data-bmo-track]');if(link)track(link.dataset.bmoTrack,link.closest('[data-bmo-root]'));
  });
})();
